export default function ($http) {
    return function (dealerId) {
        return $http.get(`/api/vmcaccount/${dealerId}`).then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/detail/vmcAccountDetail.js